<template>
  <div class="input-group">
    <span class="input-group-addon" :class="addonClass" :id="`sizing-addon${id}`"><span aria-hidden="true" class="glyphicon" :class="iconString"></span></span>
    <StoreConnectedInput :class="inputClass" class="form-control" :action="action" :store="store" :name="name" :sub-prop="subProp" :field="field" :aria-describedby="`sizing-addon${id}`" :readonly="readonly" :debounce="debounce" :required="required" :placeholder="placeholder"></StoreConnectedInput>
  </div>
</template>

<script>
  import StoreConnectedInput from './StoreConnectedInput.vue';

  export default {
    name: 'StoreConnectedInputGroup',
    components: {
      StoreConnectedInput,
    },
    props: {
      store: {
        type: String,
        required: true,
      },
      action: {
        type: String,
        default: 'setProperty',
      },
      name: {
        type: String,
        required: true,
      },
      subProp: {
        default: null,
      },
      field: {
        type: String,
      },
      type: {
        type: String,
        default: 'text',
      },
      icon: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      debounce: {
        type: Boolean,
        default: true,
      },
      required: {
        type: Boolean,
        default: false,
      },
      inputClass: {
        type: String,
        default: '',
      },
      addonClass: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        model: null,
        id: null,
      };
    },
    computed: {
      iconString() {
        return `glyphicon-${this.icon}`;
      }
    },
    mounted() {
      this.id = this._uid;
    },
  };
</script>
